import { useMutation } from '@tanstack/react-query';
import { getAxiosInstance } from '../../../axiosInstances/axios';
import { getPrivateAxiosInstance } from '../../../axiosInstances/axiosPrivate';
import {
  ApplicationReqBody,
  UpdateAppReqBody,
} from '../../../types/applications';
import { AcademiaResponse } from '../../../types/common';

const useApplicationActions = () => {
  // mutation function to create new application declared here
  const createNewApplicationHandler = useMutation({
    mutationFn: async ({
      body,
    }: {
      body: ApplicationReqBody;
    }): Promise<AcademiaResponse<null>> => {
      const response = await getAxiosInstance('user').post(
        '/associate/application/',
        body
      );

      return response.data;
    },
  });

  const updateApplicationHandler = useMutation({
    mutationFn: async ({
      uuid,
      body,
    }: {
      uuid: string;
      body: UpdateAppReqBody;
    }): Promise<AcademiaResponse<null>> => {
      const response = await getPrivateAxiosInstance('user').patch(
        `/partial/update/associate/application/${uuid}/`,
        body
      );

      return response.data;
    },
  });

  return { createNewApplicationHandler, updateApplicationHandler };
};

export default useApplicationActions;
